var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopThreeKills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97999 15.816C8.53652 15.816 8.10296 15.7729 7.68286 15.6917L6.65454 16.4352C7.38922 16.6655 8.17033 16.7898 8.97999 16.7898C9.79987 16.7898 10.5904 16.6621 11.3331 16.4261L10.3088 15.6855C9.87887 15.7709 9.4346 15.816 8.97999 15.816Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3389 2.3841L7.68804 1.31787C5.0199 1.76518 2.80728 3.57297 1.79059 6.00151L2.86108 5.99908C3.73847 4.21745 5.37123 2.87231 7.3389 2.3841Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21084 9.79923L1.19073 9.05444C1.2051 11.1516 2.05236 13.0542 3.41765 14.4479L3.76181 13.3802C2.9269 12.3871 2.36968 11.1532 2.21084 9.79923Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7453 9.83114C15.5833 11.1571 15.0394 12.3665 14.227 13.3458L14.5723 14.417C15.9135 13.0328 16.7467 11.154 16.7687 9.08398L15.7453 9.83114Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0986 5.99891L16.1691 6.00141C15.1578 3.58577 12.9633 1.78413 10.3143 1.32495L10.6646 2.39471C12.6127 2.89186 14.2278 4.2305 15.0986 5.99891Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5623 17.5596L12.4563 11.0268L18 6.97933L11.1361 6.96363L9 0.44043L6.86394 6.96363L0 6.97933L5.54363 11.0268L3.43751 17.5596L9 13.5378L14.5623 17.5596Z",
    fill: "#808080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopThreeKills);
export default __webpack_public_path__ + "static/media/topThreeKills.d484aca2819a6a83c7e3ffaf2403bca6.svg";
export { ForwardRef as ReactComponent };